import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import store from './redux/store';
import App from './App';

if (typeof window !== 'undefined' && window.ResizeObserver) {
    const OriginalRO = window.ResizeObserver;

    // Replace ResizeObserver with a safe wrapper
    window.ResizeObserver = class SafeResizeObserver extends OriginalRO {
        constructor(callback) {
            // Wrap the provided callback so it runs inside requestAnimationFrame and is try/catch'd
            super((entries, observer) => {
                try {
                    requestAnimationFrame(() => {
                        try {
                            callback(entries, observer);
                        } catch (cbErr) {
                            // swallow only ResizeObserver-related internal noise to avoid crashes,
                            // but still log other unexpected errors for debugging.
                            const msg = cbErr && cbErr.message ? cbErr.message : '';
                            if (!msg.includes('ResizeObserver loop completed')) {
                                // you can comment this out in production if noisy
                                console.error('[ResizeObserver callback error]', cbErr);
                            }
                        }
                    });
                } catch (err) {
                    // defensive: if requestAnimationFrame or wrapper throws for some reason
                    console.error('[SafeResizeObserver wrapper error]', err);
                }
            });
        }
    };

    // keep prototype chain usable (some libs check ResizeObserver.prototype)
    try {
        window.ResizeObserver.prototype = OriginalRO.prototype;
    } catch (e) {
        // ignore if not writable
    }
}

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);
